import MaterialBox, { BoxProps } from "@mui/material/Box";
import React, { FC } from "react";

interface IProps extends BoxProps {
  src?: string;
  alt?: string;
}

export const Box: FC<IProps> = (props) => <MaterialBox {...props} />;
